<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-users" texto-titulo="Nuevo cliente"></TituloComponent>
    <div class="main-card mb-3 card col-md-6 offset-md-3">
      <div class="card-body">
        <form @submit.prevent="guardarCliente()">
          <div class="row">
<!--            <float-label label="Codigo" clase="col-12">-->
<!--              <input v-model="cliente.codigo" id="codigo" placeholder="Codigo" type="text" class="form-control" :class="(enviado && !$v.cliente.codigo.required) ? 'is-invalid' : ''" />-->
<!--              <template v-slot:validation >-->
<!--                <div class="invalid-feedback" v-if="enviado && !$v.cliente.codigo.required">Codigo requerido</div>-->
<!--              </template>-->
<!--            </float-label>-->
            <float-label label="Nombre" clase="col-12">
              <input v-model="cliente.nombre" id="nombre" placeholder="Nombre" type="text" class="form-control" :class="(enviado && !$v.cliente.nombre.required) ? 'is-invalid' : ''" />
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.nombre.required">Nombre requerido</div>
              </template>
            </float-label>
            <float-label label="N° documento:" clase="col-12">
              <input v-model="cliente.numero_documento" id="numero_documento" placeholder="99999999" inputmode="numeric" type="text" class="form-control" :class="(enviado && !$v.cliente.numero_documento.numeric) ? 'is-invalid' : ''"/>
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.numero_documento.numeric">Usar solo números</div>
              </template>
            </float-label>
            <float-label label="Domicilio:" clase="col-12">
              <input v-model="cliente.domicilio" id="domicilio" placeholder="Domicilio" type="text" class="form-control"/>
            </float-label>
            <float-label label="Localidad:" clase="col-12">
              <input v-model="cliente.localidad" id="localidad" placeholder="Localidad" type="text" class="form-control"/>
            </float-label>
            <float-label label="Código postal:" clase="col-12">
              <input v-model="cliente.codigo_postal" id="codigo_postal" placeholder="Cod. Postal" inputmode="numeric" type="text" class="form-control" :class="(enviado && !$v.cliente.codigo_postal.numeric) ? 'is-invalid' : ''"/>
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.codigo_postal.numeric">Usar solo números</div>
              </template>
            </float-label>
            <float-label label="Teléfono:" clase="col-12">
              <input v-model="cliente.telefono" id="telefono" placeholder="Teléfono" type="text" class="form-control"/>
            </float-label>
            <float-label label="Empleado:" clase="col-12">
              <select v-model="cliente.user_id" id="user_id" class="form-control" :class="(enviado && !$v.cliente.user_id.required) ? 'is-invalid' : ''">
                  <option value="null">Seleccione una opción</option>
                  <option v-for="user in users" :key="user.id" :value="user.id">{{user.nombre}}</option>
              </select>
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.user_id.required">Seleccionar IVA</div>
              </template>
            </float-label>
            <float-label label="IVA:" clase="col-12">
              <select v-model="cliente.responsabilidad_iva_id" id="responsabilidad_iva_id" class="form-control" :class="(enviado && !$v.cliente.responsabilidad_iva_id.required) ? 'is-invalid' : ''">
                  <option value="null">Seleccione una opción</option>
                  <option v-for="iva in responsabilidadesIva" :key="iva.id" :value="iva.id">{{iva.descripcion}}</option>
              </select>
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.responsabilidad_iva_id.required">Seleccionar IVA</div>
              </template>
            </float-label>
            <float-label label="Lista:" clase="col-12">
              <select v-model="cliente.lista_id" id="lista_id" class="form-control" :class="(enviado && !$v.cliente.lista_id.required) ? 'is-invalid' : ''">
                  <option value="null">Seleccione una opción</option>
                  <option v-for="lista in listas" :key="lista.id" :value="lista.id">{{lista.descripcion}}</option>
              </select>
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.lista_id.required">Seleccionar Lista</div>
              </template>
            </float-label>
            <float-label label="Día de visita:" clase="col-12">
              <select v-model="cliente.dia_visita" id="dia_visita" class="form-control">
                  <option value="null">Seleccione un día</option>
                  <option value="Lunes">Lunes</option>
                  <option value="Martes">Martes</option>
                  <option value="Miércoles">Miércoles</option>
                  <option value="Jueves">Jueves</option>
                  <option value="Viernes">Viernes</option>
                  <option value="Sábado">Sábado</option>
                  <option value="Domingo">Domingo</option>
              </select>
            </float-label>
          </div>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required, numeric} from 'vuelidate/lib/validators'
import BlockUI from "@/components/loaders/BlockUI";
import axios from "axios";
import Swal from "sweetalert2";
import Cliente from "@/models/cliente";
export default {
  name: "NuevoCliente",
  components: {
    TituloComponent,
    FloatLabel,
    BlockUI
  },
  data() {
    return {
      cliente: new Cliente(null, null, "", null, "", "", null, null, "", null, null, null),
      responsabilidadesIva: [],
      listas: [],
      users: [],
      loading: false,
      enviado: false
    };
  },
  validations:{
    cliente:{
      // codigo:{required},
      nombre:{required},
      numero_documento:{numeric},
      codigo_postal:{numeric},
      responsabilidad_iva_id:{required},
      lista_id:{required},
      user_id:{required},
    }

  },
  mounted(){
      this.getResponsabilidadesIva()
      this.getListas();
      this.getUsuarios();
  },
  methods: {
    guardarCliente() {
      this.enviado = true
      this.loading = true;
      this.$v.$touch();
      if(this.$v.$invalid){
        this.loading = false;
        return false;
      }
      axios
        .post("/clientes", this.cliente)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.cliente.nombre} se guardó con éxito.`
            });
            this.$router.push({ name: "ListarClientes" });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    },
    getResponsabilidadesIva(){
        axios.get('/responsabilidades-iva')
        .then(res => {
            for(let iva of res.data){
                this.responsabilidadesIva.push(iva);
            }
        })
    },
    getListas() {
      axios.get("/listas").then(res => {
        for (let lista of res.data.data) {
          this.listas.push(lista);
        }
      });
    },
    getUsuarios() {
      axios.get("/users").then(res => {
        for (let user of res.data) {
          this.users.push(user);
        }
      });
    }
  }
};
</script>
